module.exports = "/_next/static/images/fe58304536f31d813ff73c5f4f9e4dc9-nubanker-bizarch@0.75x.jpg";